module.exports = __webpack_public_path__ + "static/img/about_h5bg_09_zh.09e858d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/about_h5bg_09_zh.png
// module id = LOiP
// module chunks = 34